import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div className='h-screen flex justify-center items-center'>
      <div className='spinner'></div>
    </div>
  )
}

export default Spinner
